// src/api/fetchPurchasedMeals.js
import { getAuth } from "firebase/auth";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchPurchasedMealIds = async () => {
  const auth = getAuth();
  const user = auth.currentUser;

  if (!user) throw new Error("User not logged in");

  const token = await user.getIdToken();

  const res = await fetch(`${API_BASE_URL}/api/orders`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) throw new Error("Failed to fetch orders");

  const orders = await res.json();

  // Flatten all mealIds from all orders
  const mealIds = orders.flatMap(order =>
    order.items.map(item => item.mealId)
  );

  return [...new Set(mealIds)]; // remove duplicates
};
